import { render, staticRenderFns } from "./CreateNovel.vue?vue&type=template&id=655736db&scoped=true&"
import script from "./CreateNovel.vue?vue&type=script&lang=js&"
export * from "./CreateNovel.vue?vue&type=script&lang=js&"
import style0 from "./CreateNovel.vue?vue&type=style&index=0&id=655736db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655736db",
  null
  
)

export default component.exports